import { Link } from "react-router-dom";
import { RAPSHighlightsType } from "../../../../models/raps-highlights-model";

const EuropRightSec = (props: {content: RAPSHighlightsType}) => {
    const content = props.content;
    return (
        <div className="hero-featurette featured-member">
            <div className="featured-image fixed">
                <figure className="aside">
                    <span className="img-corners">
              <span><Link to={content.linkURL} target={content.imageTarget}><img className="img-thumbnail tmb-sq-small" alt={content.linkText} src={content.image} /></Link></span>
                    </span>
                </figure>
                <div className="hero-content">
                    <div className="badge">{content.badgeText}</div>
                    <strong className="title">{content.title}</strong>
                    <p><Link to={content.linkURL} target={content.linkTarget} className="more">{content.linkText}</Link></p>
                </div>
            </div>
        </div>
    )
}

export default EuropRightSec
